import { useTranslate } from '@refinedev/core';
import { Tag } from 'antd';
import type { ReviewOut } from '@/api/generated/schemas';

// ─── ReviewStatusTag ──────────────────────────────────────────────────────────

type ReviewStatus = 'pending' | 'accepted' | 'rejected';

const REVIEW_STATUS_COLOR: Record<ReviewStatus, string> = {
  pending: 'default',
  accepted: 'green',
  rejected: 'red',
};

export const ReviewStatusTag = ({
  record,
}: {
  record: Pick<ReviewOut, 'is_accepted' | 'is_rejected'>;
}) => {
  const t = useTranslate();
  // Accepting clears a rejection and vice versa, so at most one flag is set.
  const status: ReviewStatus = record.is_accepted
    ? 'accepted'
    : record.is_rejected
      ? 'rejected'
      : 'pending';
  return (
    <Tag color={REVIEW_STATUS_COLOR[status]}>
      {t(`feedback.reviews.status.${status}`)}
    </Tag>
  );
};

// ─── PromotedTag ──────────────────────────────────────────────────────────────

export const PromotedTag = ({ value }: { value: boolean }) => {
  const t = useTranslate();
  return (
    <Tag color={value ? 'green' : 'default'}>
      {value
        ? t('feedback.testimonials.filter.promoted')
        : t('feedback.testimonials.filter.not_promoted')}
    </Tag>
  );
};
